import { FC, MouseEvent } from "react";
import { useNavigate } from "react-router-dom";

import { Modal } from "antd";
import { ContainerOutlined } from "@ant-design/icons";

import { EditButton } from "../../ui-components/EditButton";

import { Campaign, archiveCampaign } from "../../share/campaigns/store";
import { State } from "../../utils/store";
import { useAppDispatch, useAppSelector } from "../../utils/hooks";

const { confirm } = Modal;

const nonDemoArchiveConfirmMessage =
  "This campaign will no longer be visible in your dashboard and left panel. You can find them at the bottom of the dashboard and restore them. Archiving campaigns will not affect the numbers on the “My statistics” section of your dashboard.";
const demoArchiveConfirmMessage =
  "You will delete this campaign forever, and its data cannot be restored";

interface ArchiveCampaignButtonProps {
  campaign: Campaign;
  clientSlug: string | undefined;
}

export const ArchiveCampaignButton: FC<ArchiveCampaignButtonProps> = ({
  campaign,
  clientSlug,
}) => {
  let navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { loading } = useAppSelector(
    (state: State) => state.campaigns.archiveCampaign
  );

  const handleArchiveClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    confirm({
      title: campaign.isDemo
        ? demoArchiveConfirmMessage
        : nonDemoArchiveConfirmMessage,
      onOk() {
        handleArchiveCampaign();
      },
      okButtonProps: {
        loading: loading,
        style: {
          backgroundColor: "var(--primary-color)",
          borderColor: "var(--primary-color)",
          color: "var(--white)",
        },
      },
      cancelButtonProps: {
        style: {
          backgroundColor: "var(--primary-color)",
          borderColor: "var(--primary-color)",
          color: "var(--white)",
        },
      },
    });
  };

  const handleArchiveCampaign = () => {
    dispatch(archiveCampaign({ campaignUUID: campaign.uuid }));
    navigate(`/${clientSlug}/dashboard`);
  };

  return (
    <EditButton
      icon={<ContainerOutlined />}
      onClick={handleArchiveClick}
      className="archive-campaign-button"
    >
      Archive
    </EditButton>
  );
};
